import React from 'react';
import './Login.css';
import { connect } from 'react-redux';
import _isEqual from 'lodash/isEqual';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { verifyToken, updatePassword } from '../actions';
import axios from 'axios';
import { ROOT_URL } from './../actions'
import PasswordIndicator from './password-indicator';
import { checkPasswordStrength } from '../helper';

function jsonToParam(param, startWith) {
  if (param) {
      let paramArr = [];
      Object.keys(param).forEach(function (key) {
          if (typeof param[key] != 'object')
              paramArr.push(encodeURIComponent(key) + '=' + encodeURIComponent(param[key]));
      });
      return startWith ? startWith + paramArr.join('&') : paramArr.join('&');
  } else {
      return '';
  }
}

class ResetPassswordScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    token: "",
    email :"",
    newPassword: "",
    confirmNewPassword: "",
    tokenvalidated:0,
    imageUrl: "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABZ0RVh0Q3JlYXRpb24gVGltZQAxMC8yOS8xMiKqq3kAAAAcdEVYdFNvZnR3YXJlAEFkb2JlIEZpcmV3b3JrcyBDUzVxteM2AAABHklEQVRIib2Vyw6EIAxFW5idr///Qx9sfG3pLEyJ3tAwi5EmBqRo7vHawiEEERHS6x7MTMxMVv6+z3tPMUYSkfTM/R0fEaG2bbMv+Gc4nZzn+dN4HAcREa3r+hi3bcuu68jLskhVIlW073tWaYlQ9+F9IpqmSfq+fwskhdO/AwmUTJXrOuaRQNeRkOd5lq7rXmS5InmERKoER/QMvUAPlZDHcZRhGN4CSeGY+aHMqgcks5RrHv/eeh455x5KrMq2yHQdibDO6ncG/KZWL7M8xDyS1/MIO0NJqdULLS81X6/X6aR0nqBSJcPeZnlZrzN477NKURn2Nus8sjzmEII0TfMiyxUuxphVWjpJkbx0btUnshRihVv70Bv8ItXq6Asoi/ZiCbU6YgAAAABJRU5ErkJggg==)"
  }
}
  componentDidMount(){
    axios.get(ROOT_URL + '/recover' + this.props.location.search)
    .then(res => {
      if(res.status === 200){
        this.setState({tokenvalidated : 1})
        console.log(res);
        console.log(res.data.groupId);
        // let userInfo = jwt(res.data.jwtToken);
         localStorage.setItem("imark-token", res.data.jwtToken);
         localStorage.setItem("imark-userType", res.data.userType);
         localStorage.setItem("imark-userId", res.data.userId);
         localStorage.setItem("imark-groupId",res.data.groupId);
        //  localStorage.setItem("imark-groupId",res.data.userId);
         localStorage.setItem("imark-Name",res.data.firstName);
         sessionStorage.setItem("imark-buyingGroupId", res.data.buyingGroupId);
           sessionStorage.setItem("imark-memberId", res.data.groupId);
           sessionStorage.setItem("imark-vendorId", res.data.groupId);
           localStorage.setItem("imark-buyingGroupId", res.data.buyingGroupId);
           localStorage.setItem("imark-memberId", res.data.groupId);
           localStorage.setItem("imark-vendorId", res.data.groupId);
           sessionStorage.setItem("imark-memberName", res.data.groupName);
           sessionStorage.setItem("imark-vendorName", res.data.groupName);
         axios.defaults.headers.common['Authorization'] = "Bearer " + res.data.jwtToken;
        //  this.props.history.push('/');
      }else{
        this.setState({ errorMessage:res.message });
      }
    })
  //   const {  token,email } = this.state;
  //  // let modifiedPath = this.props.location.pathname;
  //   let modifiedPath = this.props.location.search;
  //  // let params = queryString.parse(url);
  //   //console.log(params);
  //   let modifiedPathArr = modifiedPath.split("?");
  //   console.log(modifiedPathArr)
  //   let tokenval = modifiedPathArr[1].slice(2)
  //   this.setState({ token: tokenval })
    // window.history.replaceState({}, document.title +"/recover")

  }

  updatePassword = (e) => {
      e.preventDefault();
      toast.configure({
        autoClose: 5000,
        draggable: false,
        position: toast.POSITION.BOTTOM_RIGHT
        //etc you get the idea
      });
      const { newPassword, confirmNewPassword, token,email } = this.state;
      if(_isEqual(newPassword, confirmNewPassword)){
        if (checkPasswordStrength(newPassword) == 4)
        {
        this.props.updatePasswordAPI({  
          newPassword: newPassword,
            // token: "Bearer " + token,
             
        }).then(res=>{
          toast("Password changed successfully")
          this.props.history.push('/');
        });
      }
      else{
        toast("week password , please give strong password")
    }
      }
      else{
        toast("Password and Confirm Password does not match")
      }

  }

  render() {
if(this.state.tokenvalidated)
{
    return (
      <div>
           <nav className=" Filters navbar">
        <div className="imgContainer" style={{ marginLeft: "20px" }}>
        {/* <h3 style= {{marginLeft: '50px',"font-family": 'Fantsy', color: 'rgb(255, 127, 14)' , 'font-size':' xx-large' ,'font-variant': 'proportional-nums','text-decoration': 'underline','textDecorationStyle': "double"}} >Rebate.ai</h3> */}
                      
            <img height="25" src={process.env.PUBLIC_URL + '/IMARK Logo.png'} alt="img  " />
          </div>
        </nav>
        <main class="markLogin" style={{ backgroundImage: this.state.imageUrl }}>
        <form className="form-signin">
            <h3 className="mt-5 h3 mb-3 font-weight-normal desc">Enter Your New Password</h3>
            <label for="inputEmail" className="sr-only">New Password</label>
            <input type="password" id="inputPassword" className="form-control" placeholder="New Password" required="" autofocus="" onChange={(e) => { this.setState({newPassword: e.target.value}) }} />
            <PasswordIndicator value={this.state.newPassword} />

            <label for="inputPassword" className="sr-only">Confirm New Password</label>
            <input type="password" id="inputConfirmPassword" className="form-control" placeholder="Confirm New Password" required="" onChange={(e) => { this.setState({confirmNewPassword: e.target.value}) }} />
            
            <div className="row loginRow">
              <div className="col-6">
                <button className="btn btn-md btn-primary btn-block" onClick={(e) => this.updatePassword(e)}>Save</button>
              </div>
            </div>


          </form>
        </main>
        
      </div>
    )
}
else 
return "Validating......";
  }
}

function mapStateToProps(state) {
  return {
  }
}

export default connect(mapStateToProps, {
  verifyTokenAPI: verifyToken,
  updatePasswordAPI: updatePassword
})(ResetPassswordScreen);